<div class="avatar {{ colorClass }} {{ sizeClass }}" ngbTooltip="{{ title?title : ('Page.Responses.' + type | translate) }}">
  <img [ngClass]="{'dissed': dissed }" src="{{ this.colorIconUrl }}">
</div>